import Head from "next/head";

//local imports
import FulfillmentPartner from "@/components/partners/fulfillment";
import SeoMetaData from "@/components/utils/seo-metadata";
import seoData from "@/data/seo/page-data.json";

export default function Technology() {
  return (
    <>
      <Head>
        <title>{seoData.FULFILLMENT_PARTNER.title}</title>
        <SeoMetaData data={seoData.FULFILLMENT_PARTNER} />
      </Head>

      <FulfillmentPartner />
    </>
  );
}
